module.exports = __webpack_public_path__ + "static/media/seat.c1434300.svg";